import React from 'react';
import { HeartHandshake } from 'lucide-react';
export function SelfHelpSection() {
  return <section id="self-help" className="py-20 md:py-28 bg-[#F5F0E8]" data-id="element-774">
      <div className="container mx-auto px-4 max-w-4xl text-center" data-id="element-775">
        <div className="mb-12 flex flex-col items-center" data-id="element-776">
          <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mb-6 shadow-sm" data-id="element-777">
            <HeartHandshake className="w-8 h-8 text-[#D4A843]" data-id="element-778" />
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-[#0A5E5C] mb-6" data-id="element-779">
            Самодопомога
          </h2>
          <div className="h-1 w-24 bg-[#D4A843] mx-auto rounded-full" data-id="element-780" />
        </div>

        <div className="space-y-6 text-lg text-gray-700 leading-relaxed text-left md:text-center" data-id="element-781">
          <p className="font-medium text-xl text-[#0A5E5C]" data-id="element-782">
            Цей розділ створений для тих, хто хоче краще зрозуміти власну ігрову
            поведінку та для тих, хто намагається зрозуміти, що таке азартні
            ігри і чому вони можуть нести ризик та для тих, хто хоче оцінити
            можливі ризики від гри і отримати практичні інструменти
            самоконтролю.
          </p>

          <p data-id="element-783">
            Азартні ігри можуть бути формою розваги і приносити задоволення.
            Однак іноді, коли людина з певних причин втрачає контроль, азартні
            ігри можуть почати негативно впливати на її фінанси, емоційний стан,
            стосунки з близькими та якість життя.
          </p>

          <p data-id="element-784">
            Отже, дуже важливо бути уважним до себе, до власних емоцій,
            почуттів, реакцій та станів, які супроводжують Вас до, під час та
            після гри. Дуже важливо бути з собою у контакті і усвідомлювати все,
            що відбувається з Вами, коли Ви граєте, коли Ви думаєте про гру.
            Можливо Ви використовуєте гру для того, щоб втікти від нестерпної
            реальності, яка з якихось причин Вам не подобається. Можливо Ви
            відчуваєте під час гри неймовірне емоційне збудження, яке ніде в
            житті більше для Вас недоступне. Можливо Ви вирішили, що азартні
            ігри – це легкий спосіб заробити гроші. А можливо всі ці думки і
            відчуття є у Вас одночасно. Не відвертайтесь від них і не засуджуйте
            себе, проявіть трішки уваги до себе і якщо Ви читаєте цей текст, то
            Ви точно здатні і готові повернути контроль над своєю грою і життям
            собі. Повірте в себе. Лише Ви насправді вирішуєте, хто і що
            контролює Вас і Ваше життя, і навіть, якщо в силу певних обставин Ви
            віддали контроль над собою грі, або чомусь іншому, що захопило Вас,
            Ви точно зможете повернути цей контроль назад собі. Це Ваше
            абсолютне право, право контролювати себе і своє життя і навіть, якщо
            зараз Вам здається, що це неможливо, просто хоча б допустіть таку
            думку і спробуйте рухатись вперед і простір життя почне надавати Вам
            підтримку і допомогу на шляху повернення до себе. Ми віримо у Вас і
            Вашу силу.
          </p>
        </div>
      </div>
    </section>;
}